<template>
  <div>
    <v-app-bar fixed :color="color" style="color: white">
      <v-toolbar-title class="logo">
        <v-img max-width="112px" src="@/assets/logo_white.svg" contain />
        {{name}}
      </v-toolbar-title>
      <h3 v-show="!loggedIn">データサイエンティスト特化型求人サービス</h3>
      <div class="flex-grow-1"/>
      <v-toolbar-items v-if="!loading && !maintenance" >
        <template v-if="loggedIn" >
          <TextButton white to="/clients/chat-requests">
            求職者検索
          </TextButton>
          <TextButton white to="/clients/messages">
            {{label("messages")}}
            <Chip
                v-if="allNewCount > 0"
                color="red"
                textColor="white"
                style="margin-left: 3px"
            >
              {{allNewCount}}
            </Chip>
          </TextButton>
          <TextButton white to="/clients/candidates">
            {{label("candidates")}}
          </TextButton>
          <TextButton white to="/clients/jobs">
            {{label("jobs")}}
          </TextButton>
          <TextButton white to="/clients/images">
            {{label("images")}}
          </TextButton>
          <TextButton white to="/clients/company">
            {{label("company")}}
          </TextButton>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <TextButton white icon v-on="on">
                <v-icon>mdi-domain</v-icon>
              </TextButton>
            </template>
            <ClientMenu/>
          </v-menu>
        </template>
      </v-toolbar-items>
      <div v-if="enableLocaleSwitch">
        <v-menu offset-y>
          <template v-slot:activator="{on}">
            <TextButton v-on="on" left-icon="mdi-earth" right-icon="mdi-chevron-down"/>
          </template>
          <v-list>
            <v-list-item @click="onChangeLangJapanese" :class="langJaClass">
              {{label("langJapanese")}}
            </v-list-item>
            <v-list-item @click="onChangeLangEnglish" :class="langEnClass">
              {{label("langEnglish")}}
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import TextButton from "../atoms/TextButton";
  import ComponentMixin from "../ComponentMixin";
  import _size from "lodash/size"
  import _filter from "lodash/filter"
  import ApiMixin from "../../ApiMixin";
  import ClientMenu from "@/components/organisms/ClientMenu";
  import Chip from "@/components/atoms/Chip";

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "organism",
    name: "ClientNavBar",
    props: {
      name: String,
      color: String
    },
    data () {
      return {
      }
    },
    created () {
      const locale = localStorage.getItem('locale');
      if (locale) {
        this.$i18n.locale = locale;
      } else {
        this.onChangeLangJapanese();
      }
    },
    computed: {
      ...mapGetters("user", ["user", "notifications"]),
      ...mapGetters("message", ["allNewCount"]),
      ...mapGetters("client", ["company"]),
      loading () {
        return this.$auth.loading
      },
      maintenance () {
        return process.env.VUE_APP_MAINTE
      },
      loggedIn () {
        return this.$auth.isAuthenticated
      },
      notReadNotificationNumber () {
        return _size(_filter(this.notifications, notif => !notif.isRead));
      },
      showNotReadNotificationBadge () {
        return this.notReadNotificationNumber > 0;
      },
      langJaClass () {
        return this.$i18n.locale === 'ja' ? 'activeLang' : '';
      },
      langEnClass () {
        return this.$i18n.locale === 'en' ? 'activeLang' : '';
      },
      enableLocaleSwitch () {
        return process.env.VUE_APP_ENABLE_LOCALE_SWITCH === "true";
      }
    },
    methods: {
      ...mapActions("user", ["updateNotificationsIsRead"]),
      async login () {
        this.$auth.loginWithRedirect({
          ui_locales: this.$i18n.locale
        })
      },
      handleLogout () {
        this.$auth.logout({
          returnTo: process.env.VUE_APP_AUTH0_REDIRECT_URL || `${window.location.origin}`
        })
      },
      onChangeLangJapanese () {
        this.$i18n.locale = 'ja';
        localStorage.setItem('locale', 'ja');
        this.loadConsts('ja');
      },
      onChangeLangEnglish () {
        this.$i18n.locale = 'en';
        localStorage.setItem('locale', 'en');
        this.loadConsts('en');
      }
    },
    components: {
      Chip,
      ClientMenu,
      TextButton,
    },
    watch: {
      "company.id": {
        handler: function (value) {
          if (value) {
            this.loadCompanyMessages(value)
          }
        },
        immediate: true
      },
    }
  }
</script>

<style scoped lang="sass">
.logo
  margin: 0 30px

.v-list-item
  color: white

.activeLang
  font-weight: bold

.inquiryBtn
  color: #2f3e6d
  font-weight: bold
  background-color: white
  height: 40px
  margin-left: 8px
</style>
